import React, { Component } from 'react';
import {GetData,PostData, PutData} from '../../services/PostData';
import axios from 'axios';
import {apiConfig} from "../../config/api";
import { Button, Collapse, Modal, Alert } from 'react-bootstrap';
import Loader from 'react-loader-spinner'
import debounce from "lodash.debounce";
import Pagination from "react-js-pagination";
import dateFormat from 'dateformat';

let BaseURL = apiConfig.WEB_SERVICE_URL;

class SpeechGenerate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userInput: '',
            selectedVoice: '',
            selectedCategory: 'all',
            voices: [],
            categories: ['all', 'Male', 'Female', 'Child'],
            isVoiceSelected: false,
            isMessage: false,
            isSuccessfull: false,
            sucsmsg: 'Text converted to speech successfully',
            successmsg: '',
            errormsg: '',
            isValidateForm: true,
            audioUrl: null,
            audioBlob: null,
            tempSpeechList: [],
            speechList: [],
            displaytype:'speechList',
            activeTab: 'speechList',
            voiceName: '',
            voiceAccent: '',
            gender: '',
            description: '',
            age: '',
            use_case: '',
            showAddToProject:false,
            Inloading: false,
            projectlist:[],
            selectedSpeechForPrj: {},
            tempSpeechId: 0,
            activePage: 1,
			itemPerPage:10,
            activeitemid:'',
            activeitemtype:'',
            activeitem:'',
            expandedIndex: null,
            limit: 300,
            isDeleteShow: false,
            isNotDeleteShow: false
        };
    }

    componentDidMount() {
        this.fetchVoices();
        const query = new URLSearchParams(this.props.location.search);
        const id = query.get('id');

        if(id){
            // this.setState({})
            GetData(`/get/script/${id}`).then((result) => {
                this.setState({
                    userInput: result.script.scriptForSpeech,displaytype: 'createSpeech', activeTab: 'createSpeech'
                });
            });
        }
        this.setState({Inloading: true})
        this.fetchSpeechList();

        this.setState({ Inloading: true});
        Promise.all([this.getProjectList()])
        .then(([projectdata])  => {
            if(projectdata.statuscode===200)
            {
                this.setState({projectlist:projectdata.data});
            }
        });              
    }
    

    // Method to fetch voice data from an API
    fetchVoices = async () => {
        GetData('voice/list').then((result) => {
            this.setState({voices: result.voiceList.voices})
        });
        // this.fetchSpeechList();
    }

    fetchSpeechList = () => {
        GetData(`get/all/speech/list/${this.props.match.params.orgid}`).then((result) => {
            this.setState({speechList: result.speechList, Inloading: false})
        });
    }

    handleInputChange = (event) => {
        this.setState({
            userInput: event.target.value
        });
    }

    // Method to handle form submission
    handleVoiceSubmit =async (event) => {
        event.preventDefault();
        let userdata = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data;

        if(this.validateForm()){
            this.setState({Inloading: true})
            let data = {
                text: this.state.userInput,
                voice_settings: {
                    stability: 0.1,
                    similarity_boost: 0.3,
                    style: 0.2
                }
            }
            const response = await axios.post(`https://api.elevenlabs.io/v1/text-to-speech/${this.state.selectedVoice}`, data, {
                headers: {
                    'xi-api-key': 'sk_cf9ad6f7b71d59b2f7e6afb7d3cb16b27e33f279575de36e'
                },
                responseType: 'blob'
            })

            console.log('eleven lab response-->', response)
           // Create a URL for the blob
            const audioUrl = URL.createObjectURL(response.data);
            
            const latestTempSpeechId = this.state.tempSpeechList.length === 0 ? 1 : this.state.tempSpeechId + 1;

            this.setState({tempSpeechId: latestTempSpeechId });

            let fileName = this.generateUniqueFileName(`audio.mp3`, {voiceName: this.state.voiceName, voiceAccent: this.state.voiceAccent, gender: this.state.gender})

            let speechObj = {
                id: latestTempSpeechId,
                text: this.state.userInput,
                voiceName: this.state.voiceName,
                voiceAccent: this.state.voiceAccent,
                gender: this.state.gender,
                description: this.state.description,
                age: this.state.age,
                use_case: this.state.use_case,
                downloadurl: audioUrl,
                audioBlob: response.data,
                isSavedToList: false,
                fileName: fileName
            }

            let newTempSpeech = [...this.state.tempSpeechList, speechObj]

            this.setState({tempSpeechList: newTempSpeech, audioUrl, audioBlob: response.data, isVoiceSelected: false,
                isMessage: true,
                isSuccessfull: true,
                userInput: '',
                selectedVoice: '',
                Inloading: false
            })

            setTimeout(() => {
                this.setState({ isMessage: false, isSuccessfull: false });
            }, 3000);
            
        }
    }

    validateForm = ()=>{
        this.setState({ isValidateForm: true })
        const userInput = this.state.userInput?.trim();
        let formIsValid = true;
        if(!this.state.isVoiceSelected && !userInput) {
            formIsValid = false;
            this.setState({errormsg: 'All fields are required', isValidateForm: false, isMessage: true})
        } else if(!this.state.isVoiceSelected){
            formIsValid = false;
            this.setState({errormsg: 'Please select any voice', isValidateForm: false, isMessage: true})
        }else if(!userInput){
            formIsValid = false;
            this.setState({errormsg: 'Please type something..', isValidateForm: false, isMessage: true})
        }
        return formIsValid
    }

    handleVoiceSelection = (event) => {
        
        // Find the full voice object based on the selected voice_id
        const selectedVoice = this.state.voices.find(voice => voice.voice_id === event.target.value);
        
        this.setState({
            selectedVoice: event.target.value,
            isVoiceSelected: true,
            voiceName: selectedVoice.name,
            voiceAccent: selectedVoice.labels.accent,
            gender: selectedVoice.labels.gender,
            description: selectedVoice.labels.description,
            age: selectedVoice.labels.age,
            use_case: selectedVoice.labels.use_case,
        });
    }

    // Method to handle category filter selection
    handleCategoryChange = (event) => {
        this.setState({
            selectedCategory: event.target.value
        });
    }

    // Get filtered voices based on selected category
    getFilteredVoices = () => {
        const { voices, selectedCategory } = this.state;
        if (selectedCategory === 'all') {
            return voices;
        }
        return voices.filter(voice => voice.category === selectedCategory);
    }

    handleButtonClick = (voice) => {
        // Handle button click (e.g., play audio, edit, delete)
        console.log(`Button clicked for: ${voice.text}`);
        // You can add any specific functionality here
    }

    changeView(displaytype){
        this.setState({ displaytype: displaytype, activeTab: displaytype });
        if(displaytype === 'speechList') {
            this.fetchSpeechList();
        }
    }

    generateUniqueFileName = (originalName, voiceInfo) => {
        const timestamp = Date.now();
        const name = `${voiceInfo.voiceName}_${voiceInfo.voiceAccent}_${voiceInfo.gender}`;
        const fileExtension = originalName.split('.').pop();
        return `audio_${name}_${timestamp}.${fileExtension}`;
    }

    handleSaveSpeech = async (voiceDetail) =>{

        let userdata = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data;
        let session_key = userdata.token;

        const formData = new FormData();

        let fileName = this.generateUniqueFileName('audio.mp3', voiceDetail)

        formData.append('audio', voiceDetail.audioBlob, fileName);
        formData.append('text', voiceDetail.text);
        formData.append('userId', userdata.user.ID);
        formData.append('orgId', this.props.match.params.orgid);
        formData.append('voiceName', voiceDetail.voiceName);
        formData.append('voiceAccent', voiceDetail.voiceAccent);
        formData.append('gender', voiceDetail.gender);
        formData.append('description', voiceDetail.description);
        formData.append('age', voiceDetail.age);
        formData.append('use_case', voiceDetail.use_case);

        try {
            const response = await axios.post(BaseURL + '/save/speech', formData, {
              headers: {
                'session-key': session_key, 
                'Content-Type': 'multipart/form-data',
              },
            });
            
            let updatedArray = this.state.tempSpeechList.map(item => {
                if (item.id === voiceDetail.id) {
                    return { ...item, isSavedToList: true };
                }
                return item;
            });
            this.setState({tempSpeechList: updatedArray})
        } catch (error) {
            console.error('Error saving audio:', error);
        }
    }

    handleProjectSelect = (speechDetails) => {
        let userdata = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data;
        this.setState({ 
            selectedSpeechForPrj: {
                filename: speechDetails.fileName,
                fileid: speechDetails.fileid,
                filetype: speechDetails.filetype,
                text: speechDetails.text,
                draft_box_id: speechDetails.fileid,
                isUploadToBox: true,
                userid: userdata.user.ID
            },
            showAddToProject: true
        });
    }

    handleAddToProjectClose(e) {
        this.setState({
            showAddToProject: false,
        });
    }

    handleProjectChange(e){
        console.log('selectedproject==',e.target.value);
        this.setState({ selectedproject: e.target.value });
    }

    getProjectList(){
        return GetData('orgprojectlist/'+this.props.match.params.orgid).then((result) => {
            return result;
        });
    }

    addSpeechToProject(e){
        // let filedetails = this.state.filedetails;
        //console.log('filedetails==',filedetails);
        if(this.state.selectedproject=='') {
            this.setState({
                errormsg:'Please select Project'
            })
        } else {
            this.setState({
                errormsg:''
            })
            console.log('selectedproject', this.state.selectedproject)

            PostData('add/textToSpeech/to/projectBoard', {
                ...this.state.selectedSpeechForPrj,
                project_id: this.state.selectedproject,

            }).then(async (result) => {
                
                if (result.statuscode === 200) {
                    this.setState({ successmsg: result.message });
                }

                setTimeout(() => this.setState({ successmsg: '',selectedproject:'', selectedSpeechForPrj:{}, showAddToProject:false }), 3000);
            });
        }

    }

    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });
    }

    toggleText = (index) => {
        this.setState({ expandedIndex: this.state.expandedIndex === index ? null : index });
    };

    handleDeleteSpeech = (speech) =>{
        PutData(`delete/speech/${speech._id}`, {}).then(async (result) => {
            
            if (result.success) {
                let updatedArray = this.state.speechList.filter(item => item._id !== result.speech._id);
                this.setState({ speechList: updatedArray, deleteMsg: 'Speech deleted successfully', isDeleteShow: true });
            } else {
                this.setState({ deleteMsg: 'Speech not deleted. Please try again.', isNotDeleteShow: true });
            }

            setTimeout(() => this.setState({ deleteMsg: '', isNotDeleteShow: false, isDeleteShow: false }), 3000);
        });
    }

    handleAlertClose = () =>{
        this.setState({isDeleteShow: false, isNotDeleteShow: false})
    }

    render() {
        const { selectedVoice, activeTab } = this.state;
        let projects = this.state.projectlist.map((item, i) => {
            return <option key={i} className="folderlistitem" value={item._id}>
                {item.project_name}
            </option>;
        });
        let indexOfLastTodo = this.state.activePage * this.state.itemPerPage;
		let indexOfFirstTodo = indexOfLastTodo - this.state.itemPerPage;
        let renderedSpeeches = this.state.speechList.slice(indexOfFirstTodo, indexOfLastTodo);
        // const filteredVoices = this.getFilteredVoices();
        let listItems = renderedSpeeches.map((item, index) => {
            const isExpanded = this.state.expandedIndex === index;
            const displayedText = isExpanded ? item.text : (item.text ?item.text.substring(0, this.state.limit): item.text);
            return <tbody>
                <tr key={index}>
                <td className="tbl_org_duedate">{item.voiceName}</td>
                    <td className='audio-player-tb'>
                        <div>
                            <audio controls className="audio-player">
                                <source src={item.downloadurl} type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                        </div>
                    </td>
                    <td className="tbl_org_name speech-text">
                        {/* <p style={{marginBottom: '0px'}}>{item.text.substring(0, 100)}</p> */}
                        <div style={{marginBottom: '0px',}}>
                            {/* {item.text} */}
                            {displayedText}
                            {!isExpanded && item.text && item.text.length > this.state.limit && `...`}
                            {item.text && item.text.length > this.state.limit && (
                                <span onClick={() => this.toggleText(index)} className='span-sm-sl'>
                                    {isExpanded ? 'Show Less' : 'Show More'}
                                </span>
                            )}
                        </div>
                    </td>
                    {/* <td className="tbl_org_duedate">{item.accent}</td>
                    <td className="tbl_org_duedate">{item.gender}</td>
                    <td className="tbl_org_duedate">{item.description}</td>
                    <td className="tbl_org_duedate">{item.age}</td>
                    <td className="tbl_org_duedate">{item.use_case}</td> */}
                    <td className="tbl_org_duedate">{dateFormat(item.createdAt, "mm/dd/yyyy")}</td>
                    <td className=" TblIconDel addPB-btn-tb">
                        <button class="UpdateBtn btn btn-primary" onClick={()=>{this.handleProjectSelect(item)}} >Add to project</button>
                        <i  className="fa fa-trash" aria-hidden="true"  onClick={(e) => { if (window.confirm('Are you sure you want to delete?')) this.handleDeleteSpeech(item) } } > <img src={require('../../assets/images/delete-icon.png')}/> </i>
                    </td>

                </tr>
                {/* {(this.state.activeitemid === item._id &&
                    <tr>
                        <td style={{ width: "100%" }}>
                            <ItemData itemtype={this.state.activeitemtype} item={this.state.activeitem} />
                        </td>
                    </tr>
                )
                } */}
            </tbody>
        });

        return (
            <div className='speech-main-div'>
                <div className='genSpeedHeading'>
                    <h3 className='speechPageHeading'>Create Voice Over</h3>
                </div>
                {
                    this.state.Inloading ?
                        <div className="loaderspinner">
                            <Loader
                                type="TailSpin"
                                color="#D10000"
                                height={100}
                                width={100}
                            />
                        </div>
                        : null
                }
                <div className='speech-container ProAssetsList'>
                    <div className="row speechTabs">
                        <div className="col-12 col-sm-12 col-md-12 MobOrgProTab">
                            <ul className="top-links">
                                <li>
                                    {/* <a className={`forcusror speechtab-link ${activeTab === 'createSpeech' ? 'active' : ''}`} onClick={this.changeView.bind(this,'createSpeech')} > */}
                                    <a className={`forcusror`} onClick={this.changeView.bind(this,'createSpeech')} >
                                    Create Speech</a>  
                                </li>
                               
                                <li> 
                                    {/* <a className={`forcusror speechtab-link ${activeTab === 'speechList' ? 'active' : ''}`} onClick={this.changeView.bind(this,'speechList')} > */}
                                    <a className={`forcusror`} onClick={this.changeView.bind(this,'speechList')} >
                                    Speech List</a>                                            
                                </li>
                            </ul>
                            <hr/>
                        </div>
                    </div>

                    {   this.state.displaytype == 'createSpeech' &&
                        <>
                        
                            <div style={{ marginTop: '20px' }}>
                                {/* <label htmlFor="voiceDropdown">Select a Voice: </label> */}
                                <select id="voiceDropdown" className="form-control" placeholder='Select voice' value={selectedVoice} onChange={this.handleVoiceSelection}>
                                    <option value="" disabled>Select a voice</option>
                                    {this.state.voices.map(voice => (
                                        <option key={voice.voice_id} value={voice.voice_id}>
                                            {voice.name}: {`${voice.labels.accent} ${voice.labels.gender}, ${voice.labels.description}, ${voice.labels.age}, ${voice.labels.use_case}`}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <div>
                                    <h5>Type your script below to convert to speech</h5>
                                </div>
                                <div>
                                    <form onSubmit={this.handleVoiceSubmit} className='speech-form'>
                                        <div>
                                            <textarea
                                                value={this.state.userInput}
                                                onChange={this.handleInputChange}
                                                placeholder="Type or paste your text here..."
                                                className="form-control"
                                                rows="10"
                                                cols="50"
                                            />
                                        </div>
                                        <div className={this.state.isMessage? 'speechAfterFormSubmit': 'speechBeforeFormSubmit'}>
                                            {/* {<div className="successmsg">{this.state.sucsmsg}</div>} */}
                                            {this.state.isSuccessfull && <div className="successmsg">{this.state.sucsmsg}</div>}
                                            {!this.state.isValidateForm && <div className="errorMsg">{this.state.errormsg}</div>}
                                            <div>
                                                <button type='submit' className="UpdateBtn btn btn-primary">Submit</button>
                                            </div>
                                        </div>
                                        
                                    </form>

                                </div>
                            </div>
                            <br/>

                            <div className="speech-list">
                                {this.state.tempSpeechList.map(voice => (
                                    <>
                                        <div key={voice.id} className="card card-wrapper">
                                            <div className="card-content">
                                                <div className='speechText'>
                                                    <p>{voice.text}</p> 
                                                </div>
                                                <hr/>
                                                <audio controls className="audio-player">
                                                    {/* <source src={`../../../speech/${voice.fileName}`} type="audio/mpeg" /> */}
                                                    <source src={voice.downloadurl} type="audio/mpeg" />
                                                    Your browser does not support the audio element.
                                                </audio>
                                                
                                            </div>
                                            <div className='speechCategory'>
                                                <span>{voice.voiceName}</span>
                                                <span>{voice.voiceAccent}</span>
                                                <span>{voice.gender}</span>
                                            </div>
                                            <div className='downloadSavebtn'>
                                                <a href={voice.downloadurl}  download={voice.fileName}>
                                                    <button class="UpdateBtn btn btn-primary"> Download </button>
                                                </a>
                                                <button disabled={voice.isSavedToList} class="UpdateBtn btn btn-primary" onClick={()=>{this.handleSaveSpeech(voice)}} > { voice.isSavedToList ? 'Saved' :'Save Speech'} </button>
                                            </div>
                                        </div>
                                    </>
                                ))}
                            </div>
                        </>
                    }
                    {/* <br /> */}
                    {/* {this.state.audioUrl && (
                        <audio controls>
                            <source src={this.state.audioUrl} type="audio/mpeg" />
                            Your browser does not support the audio element.
                        </audio>
                    )} */}

                    {   
                        this.state.displaytype == 'speechList' &&
                        <div className="">
                            {
                                this.state.Inloading ?
                                    <div className="loaderspinner">
                                        <Loader
                                            type="TailSpin"
                                            color="#D10000"
                                            height={100}
                                            width={100}
                                        />
                                    </div>
                                    : null
                            }
                            {/* {this.state.speechList.map(voice => (
                                <>
                                    <div key={voice._id} className="card card-wrapper">
                                        <div className="card-content">
                                            <div className='speechText'>
                                                <p>{voice.text}</p> 
                                            </div>
                                            <hr/>
                                            <audio controls className="audio-player">
                                                <source src={voice.downloadurl} type="audio/mpeg" />
                                                Your browser does not support the audio element.
                                            </audio>
                                            
                                        </div>
                                        <div className='speechCategory'>
                                            {voice?.voiceName && <span>{voice.voiceName},</span>}
                                            {voice?.accent && <span>{voice.accent}</span>}
                                            {voice?.gender && <span>{voice.gender}</span>}
                                        </div>
                                        <button class="UpdateBtn btn btn-primary" onClick={()=>{this.handleProjectSelect(voice)}} >Add to project</button>
                                    </div>
                                </>
                            ))} */}
                            <div className="container-fluid ProjectList" ref="selfdiv">
                                <div className="panel panel-primary">
                                    <div className="panel-body">
                                        <div className="row">
                                            { this.state.isDeleteShow && <Alert
                                                variant="danger"
                                                className='message-alert'
                                                dismissible
                                                onClose={this.handleAlertClose}
                                            >
                                                {this.state.deleteMsg}
                                            </Alert>}
                                            
                                            {this.state.isNotDeleteShow && <Alert
                                                variant="danger"
                                                className='message-alert'
                                                dismissible
                                                onClose={this.handleAlertClose}
                                            >
                                                {this.state.deleteMsg}
                                            </Alert>}
                                            <table className="table table-striped ListTable">
                                                <thead>
                                                    <tr>
                                                        <th className="tbl_org_duedate"><b>Name</b></th>
                                                        <th className="tbl_org_action"><b>Audio</b></th>
                                                        <th className="tbl_org_name"><b>Speech Text</b></th>
                                                        {/* <th className="tbl_org_description"><b>Description</b></th> */}
                                                        {/* <th className="tbl_org_duedate"><b>Accent</b></th>
                                                        <th className="tbl_org_duedate"><b>Gender</b></th>
                                                        <th className="tbl_org_duedate"><b>Description</b></th>
                                                        <th className="tbl_org_duedate"><b>Age</b></th>
                                                        <th className="tbl_org_duedate"><b>Use Case</b></th> */}
                                                        <th className="tbl_org_duedate"><b>Created Date</b></th>
                                                        <th className=""><b>Action</b></th>
                                                    </tr>
                                                </thead>
                                                {listItems}
                                            </table>
                                        </div>
                                        <div className="Mobrow">
                                            <Pagination
                                                activePage={this.state.activePage}
                                                itemsCountPerPage={10}
                                                totalItemsCount={this.state.speechList.length}
                                                pageRangeDisplayed={5}
                                                onChange={this.handlePageChange.bind(this)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>
                    }
                </div>

                <Modal show={this.state.showAddToProject}>
                    {/* {
                        this.state.Inloading ?
                            <div className="loaderspinner">
                                <Loader
                                    type="TailSpin"
                                    color="#D10000"
                                    height={100}
                                    width={100}
                                />
                            </div>
                            : null
                    } */}
                    <Modal.Header class="SelectProducerHead">
                        <Modal.Title>Add To Project</Modal.Title>
                    </Modal.Header>
                    <Modal.Body class="SelectProducerModel">
                        <div className="succes-msg">{this.state.successmsg}</div>
                        <div className="error-msg">{this.state.errormsg}</div>
                        <select name="projectname" className="form-control" value={this.state.selectedproject} onChange={this.handleProjectChange.bind(this)} >
                            <option value=" ">Select Project</option>
                            {projects}
                        </select>
                    </Modal.Body>
                    <Modal.Footer class="FullWidthModelFoot">
                        <Button variant="secondary" onClick={this.handleAddToProjectClose.bind(this)}>
                            X
                        </Button>
                        <Button variant="primary" onClick={this.addSpeechToProject.bind(this)}>
                            Add To Project
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default SpeechGenerate